import useSWRMutation from 'swr/mutation';
import letrusAPI from 'APIs/letrusAPI/axiosInstance';
import { resetSession } from 'utils/functions/resetSession';

export function useLogout() {
  return useSWRMutation<null, Error, string>(
    '/api/v1/token/logout/',
    async (url) =>
      letrusAPI(url, { method: 'post' }).then((res) => {
        resetSession();

        return res.data;
      }),
    { throwOnError: false }
  );
}
